import React, { useState } from "react";
import MultiPurposeInput from "@components/MultiPurposeInput";

import Modal from "../Modal/Modal";
import { Button } from "@components/Helpers/UIComponents";
import { RadioButtonList } from "../FormHelpers";
import { useTranslations } from "next-intl";
import { TimeInputProps } from "@interfaces/uiElementTypes";

import { convertToMtavruli } from "@utils/sync/GeneralUtils";
import { ScheduleTimeIcon } from "@assets/icons";

const TimeInput: React.FC<TimeInputProps> = ({
  options,
  selectedTime,
  setSelectedTime,
  classNameInput,
  classNameIcon,
  disabled,
}) => {
  const t = useTranslations("CustomInputs");
  const g = useTranslations("General");

  const [isOpen, setIsOpen] = useState(false);

  const handleToggleModal = () => {
    setIsOpen((prev) => !prev);
  };

  return (
    <>
      <MultiPurposeInput
        disabled={disabled}
        label={t("timeInputTitle")}
        text={options.find((opt) => opt.value === selectedTime)?.label}
        icon={<ScheduleTimeIcon />}
        isDropdown={true}
        isOpen={isOpen}
        onToggle={handleToggleModal}
        classNameInput={classNameInput}
        classNameIcon={classNameIcon}
        classNamePopup="overflow-y-auto"
      />
      <Modal
        title={t("timeInputHeader")}
        isOpen={isOpen}
        onClose={() => setIsOpen(false)}
      >
        <div className="picker-body max-h-[500px]">
          <RadioButtonList
            options={options}
            selectedValue={selectedTime}
            setSelectedValue={setSelectedTime}
            className="grid-cols-2"
          />
          <Button
            type="button"
            onClick={handleToggleModal}
            className="primary_button flex"
          >
            {g("popupButtonChoose")}
          </Button>
        </div>
      </Modal>
    </>
  );
};

export default TimeInput;
